"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Close = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var defaultSize = 10;

function Close(_a) {
  var children = _a.children,
      _b = _a.size,
      size = _b === void 0 ? defaultSize : _b,
      restProps = tslib_1.__rest(_a, ["children", "size"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    width: "".concat(size / 16, "rem"),
    height: "".concat(size / 16, "rem"),
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), children, react_1.default.createElement("path", {
    d: "M5.925 5.21999C5.94844 5.24323 5.96703 5.27088 5.97973 5.30134C5.99242 5.33181 5.99895 5.36448 5.99895 5.39749C5.99895 5.43049 5.99242 5.46317 5.97973 5.49363C5.96703 5.5241 5.94844 5.55175 5.925 5.57499L5.575 5.92499C5.55176 5.94842 5.52411 5.96702 5.49365 5.97971C5.46318 5.9924 5.43051 5.99894 5.3975 5.99894C5.3645 5.99894 5.33182 5.9924 5.30136 5.97971C5.27089 5.96702 5.24324 5.94842 5.22 5.92499L3 3.70499L0.780002 5.92499C0.756762 5.94842 0.729111 5.96702 0.698647 5.97971C0.668182 5.9924 0.635505 5.99894 0.602502 5.99894C0.569499 5.99894 0.536823 5.9924 0.506358 5.97971C0.475893 5.96702 0.448243 5.94842 0.425002 5.92499L0.0750024 5.57499C0.0515703 5.55175 0.0329718 5.5241 0.0202796 5.49363C0.00758748 5.46317 0.00105286 5.43049 0.00105286 5.39749C0.00105286 5.36448 0.00758748 5.33181 0.0202796 5.30134C0.0329718 5.27088 0.0515703 5.24323 0.0750024 5.21999L2.295 2.99999L0.0750024 0.779987C0.0515703 0.756746 0.0329718 0.729096 0.0202796 0.698631C0.00758748 0.668166 0.00105286 0.63549 0.00105286 0.602487C0.00105286 0.569484 0.00758748 0.536808 0.0202796 0.506343C0.0329718 0.475878 0.0515703 0.448228 0.0750024 0.424987L0.425002 0.0749872C0.448243 0.0515551 0.475893 0.0329566 0.506358 0.0202644C0.536823 0.00757222 0.569499 0.0010376 0.602502 0.0010376C0.635505 0.0010376 0.668182 0.00757222 0.698647 0.0202644C0.729111 0.0329566 0.756762 0.0515551 0.780002 0.0749872L3 2.29499L5.22 0.0749872C5.24324 0.0515551 5.27089 0.0329566 5.30136 0.0202644C5.33182 0.00757222 5.3645 0.0010376 5.3975 0.0010376C5.43051 0.0010376 5.46318 0.00757222 5.49365 0.0202644C5.52411 0.0329566 5.55176 0.0515551 5.575 0.0749872L5.925 0.424987C5.94844 0.448228 5.96703 0.475878 5.97973 0.506343C5.99242 0.536808 5.99895 0.569484 5.99895 0.602487C5.99895 0.63549 5.99242 0.668166 5.97973 0.698631C5.96703 0.729096 5.94844 0.756746 5.925 0.779987L3.705 2.99999L5.925 5.21999Z",
    fill: "currentColor"
  }));
}

exports.Close = Close;